import React from "react";
import { TbX } from "react-icons/tb";
import styles from "./Pricing.module.css";

const PaymentFailed = () => {
  return (
    <div className={`page-container ${styles.paymentResultPage}`}>
      <div
        className={`${styles.paymentResultIcon} ${styles.paymentResultIconFailed}`}
      >
        <TbX />
      </div>

      <h1 className={`heading ${styles.paymentResultTitle}`}>
        Payment{" "}
        <span className={styles.paymentResultTitleFailedAccent}>
          Failed!
        </span>
      </h1>
      <p className={styles.paymentResultSubtitle}>
        Your payment could not be processed
      </p>
      <p className={styles.paymentResultText}>
        We couldn&apos;t process your payment. Please check your payment
        details and try again. If you continue to experience issues, please
        contact our support team at{" "}
        <a
          href="mailto:support@ifillip.com"
          className={styles.paymentResultLink}
        >
          support@ifillip.com
        </a>
        .
      </p>
    </div>
  );
};

export default PaymentFailed;
